import FormsRenderer from './FormsRenderer'
export default FormsRenderer


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/FormsRenderer/index.js